import React from 'react';

const Image = ({config}) => {

	return <img alt="" src={"data:image/png;base64," + config.image} style={{ width: config.width + "pt", height: config.height + "pt" }} />
}

export default Image;